import { Component, ChangeDetectionStrategy } from "@angular/core";
import { Observable } from "rxjs";

import { LoaderService } from "../../../services/loader.service";

@Component({
  standalone: false,
  selector: "app-loading-bar",
  templateUrl: "./loading-bar.component.html",
  styleUrls: ["./loading-bar.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingBarComponent {
  public readonly isLoadingState$: Observable<boolean>;

  constructor(private readonly loaderService: LoaderService) {
    this.isLoadingState$ = this.loaderService.showLoader$;
  }
}
